import { NotificationProps as MantineNotificationProps, Notification } from '@mantine/core';

import classes from './Notification.module.css';

const NotificationVariantProps = {
  success: {
    color: 'mint',
    title: 'Success!',
  },
  error: {
    color: 'cerise',
    title: 'Error',
  },
  warning: {
    color: 'yellow',
    title: 'Warning!',
  },
  loading: {
    color: 'cobalt',
    loading: true,
  },
};

const NotificationDefaults = Notification.extend({
  defaultProps: { radius: 'sm', color: 'cobalt.1', maw: 400 },
  classNames: {
    root: classes.root,
    title: classes.title,
    body: classes.body,
    description: classes.description,
    icon: classes.icon,
    closeButton: classes.closeButton,
  },
});

interface NotificationProps extends MantineNotificationProps {
  variant?: keyof typeof NotificationVariantProps;
}

const _Notification = ({ variant, ...props }: NotificationProps) => {
  return (
    <Notification
      mod={{
        variant,
      }}
      {...props}
    />
  );
};

const __Notification = Object.assign(_Notification, Notification);

export { __Notification as Notification, NotificationDefaults };

export type { NotificationProps };
